/** @file Copies one bone's world affine out of pose.world (the identity for bone -1). */
import { affine } from '@pose2d/math/affine';
import type { Affine } from '@pose2d/math/types';
import { POSE_LAYOUT, type Pose } from '../contracts/pose';

/** Copies the world [a, b, c, d, tx, ty] of `bone` into out (bone -1, "no parent", writes the identity); returns out. */
export function readWorld(pose: Pose, bone: number, out: Affine): Affine {
  if (bone < 0) return affine.identity(out);
  const o = bone * POSE_LAYOUT.WORLD_STRIDE;
  for (let i = 0; i < POSE_LAYOUT.WORLD_STRIDE; i++) out[i] = pose.world[o + i] ?? 0;
  return out;
}
